export const routerLinks = {
  activities: {
    car: "/bookings/car",
    yacht: "/bookings/yacht",
    personalAssistantsTasks: "/assistant/tasks",
    rental: "/bookings/rental",
  },
  profile: {
    profileHome: "/home",
  },
  subscriptions: {
    subscriptionsHome: "/subscriptions",
  },
  administration: {
    administrationHome: "/administration",
  },
  partners: {
    cars: "/partners/cars",
    yachts: "/partners/yachts",
    rentals: "/partners/rentals",
  },
  assets: {
    carHome: "/car",
    yachtHome: "/yacht",
    rentalHome: "/rental",
  },
  customers: {
    customersHome: "/customers",
  },
  driverManagement: {
    driverHome: "/driver",
  },
  analytics: {
    analyticsHome: "/analytics",
  },
  notification: {
    notificationHome: "/notification",
  },
  settings: {
    settingHome: "/settings",
  },
  configurations: {
    configurations: "/configurations",
  },
  promoCode: {
    promoCodeHome: "/promocode",
  },
  reasonOfCancellation: {
    reasonOfCancellation: "/reason-of-cancellation",
  },
  promotions: {
    promotions: "/promotions",
  },
  company: {
    company: "/company",
  },
  setting: {
    setting: "/settings",
  },
  reports: {
    carReports: "/reports/cars",
    yachtReports: "/reports/yachts",
    rentalReports: "/reports/rentals",
    reimbursementReports: "/reports/reimbursements",
    reimbursementPartnerDetail: "/reports/reimbursements/partner-detail",
  },
  earnings: {
    earningsHome: "/earnings",
  },
  invoice: {
    invoiceHome: "/invoice",
  },
  ourfleet: {
    ourfleet: "/chauffeurMap",
  },
  kpi: {
    kpi: "/kpi",
  },
  liveFeed: {
    liveFeed: "/feed",
  },
  serviceRequests: {
    serviceRequests: "service-requests",
  },
  meeting: {
    meetingHome: "/meeting",
  },
  referral: {
    referralHome: "/referral",
    payoutDetail: "/referral/payout/",
    reimbursementDetail: "/referral/reimbursement/",
  },
};
